// Disable rule as the component is external

/* eslint-disable react/jsx-pascal-case */
import classnames from 'classnames'
import * as React from 'react'
import * as Reakit from 'reakit/Combobox'

import { Button, ButtonProps } from '../button'
import { PropsWithAs } from '../types'

const DEFAULT_ELEMENT = 'button'

export interface ComboBoxItemProps extends ButtonProps {
  /**
   * The returned object from `useComboBoxState`
   */
  state?: Reakit.unstable_ComboboxStateReturn

  /**
   * Value for the combo box item
   */
  value: string
}

export function ComboBoxItem<TagType extends React.ElementType = typeof DEFAULT_ELEMENT>({
  as: asComponent,
  state,
  children,
  ...props
}: PropsWithAs<TagType> & ComboBoxItemProps) {
  return (
    <Reakit.unstable_ComboboxOption {...state} {...props}>
      {(itemProps) => {
        const selected = state?.currentId === itemProps.id

        return (
          <Button
            {...(itemProps as any)}
            as={asComponent ?? DEFAULT_ELEMENT}
            active={selected}
            theme="menuItem"
            type="button"
            align="left"
            contentClass={classnames(props.contentClass, 'font-normal')}
          >
            {children}
          </Button>
        )
      }}
    </Reakit.unstable_ComboboxOption>
  )
}
